/**
 * 도트 아트 공용 팔레트.
 * 원작 특유의 채도 높은 색감과 굵은 갈색 외곽선을 참고해 직접 구성했다.
 */

import type { Palette } from './grid';

export const BASE_PALETTE: Palette = {
  o: '#2b1f1a', // 외곽선
  z: 'rgba(0,0,0,0.28)', // 그림자

  s: '#ffdcae', // 피부
  S: '#e3ad78', // 피부 음영
  h: '#7b4a22', // 머리
  H: '#a96a30', // 머리 하이라이트

  t: '#3f6cd6', // 상의
  T: '#2a4a9c', // 상의 음영
  p: '#a5673a', // 하의
  P: '#7d4c28', // 하의 음영
  k: '#5b3a1e', // 신발
  K: '#7d5228', // 신발 하이라이트

  w: '#eef3fa', // 검날
  W: '#a9b8cc', // 검날 음영
  g: '#e0b545', // 검 손잡이(금색)
  G: '#a97c25',

  e: '#2b1f1a', // 눈동자
  q: '#ffffff', // 눈 흰자

  r: '#e0483c', // 빨강
  R: '#a52d28',
  n: '#7ed957', // 초록
  N: '#49a03c',
  u: '#5aa8ef', // 파랑
  U: '#2f6fb5',
  y: '#ffd24a', // 노랑
  Y: '#d29a19',
  m: '#f7e7c8', // 크림
  M: '#d8bf96',
  x: '#ffffff',
  X: '#c8cfd8',
  b: '#b5793f', // 갈색
  B: '#7d5228',
  c: '#d8603a', // 보조색 1 (스왑용)
  C: '#f09a5e',
  d: '#8a5fc0', // 보조색 2 (스왑용)
  D: '#5a3a86',
};

export function withPalette(overrides: Palette): Palette {
  return { ...BASE_PALETTE, ...overrides };
}

export function hex(color: number): string {
  return `#${color.toString(16).padStart(6, '0')}`;
}

/** 원작 UI 색감을 참고한 HUD/윈도우 색 */
export const UI = {
  frameOuter: 0x1b1b24,
  frameInner: 0x3a3a4a,
  framePanel: 0x24242f,
  windowBg: 0xf2e4c4,
  windowBgDark: 0xd9c49b,
  windowTitle: 0x6a4a2a,
  windowBorder: 0x3a2a18,
  slot: 0xe8d8b4,
  slotDark: 0xc4ac82,
  hp: 0xf24949,
  hpDark: 0x8f1f1f,
  mp: 0x3c8ef0,
  mpDark: 0x1c4f8f,
  exp: 0xf2c33c,
  expDark: 0x9c7a12,
  barTrack: 0x141419,
  text: 0xffffff,
  textDim: 0xb9b9c6,
  gold: 0xf2c33c,
} as const;
